module.exports = __webpack_public_path__ + "static/media/18_l_lamp_11.88_0.d1f28864.png";